module.exports = __webpack_public_path__ + "static/media/double-left-blue.828e1f55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/double-left-blue.svg
// module id = 3222
// module chunks = 0